var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankingAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2979 9.17505H9.70224C9.50597 9.17505 9.34668 9.00771 9.34668 8.80153V0.873522C9.34668 0.667338 9.50597 0.5 9.70224 0.5H24.2982C24.4948 0.5 24.6538 0.667338 24.6538 0.873522V8.80153C24.6534 9.00771 24.4945 9.17505 24.2979 9.17505ZM10.0578 8.428H23.9427V1.24704H10.0578V8.428Z",
    fill: "#F1935C",
    stroke: "#F1935C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.736 32.0819C25.645 32.0819 25.5539 32.0453 25.4846 31.9724L18.5768 24.7153C18.51 24.6451 18.4727 24.5506 18.4727 24.4512C18.4727 24.3518 18.51 24.257 18.5768 24.1871L25.485 16.9303C25.624 16.7843 25.8487 16.7843 25.9877 16.9303L32.8958 24.1871C32.9623 24.2573 32.9997 24.3518 32.9997 24.4512C32.9997 24.5506 32.9623 24.6454 32.8955 24.7153L25.9874 31.9724C25.918 32.0453 25.827 32.0819 25.736 32.0819ZM19.331 24.4512L25.7363 31.1802L32.1417 24.4512L25.736 17.7226L19.331 24.4512Z",
    fill: "#F1935C",
    stroke: "#F1935C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26368 32.4999C4.25833 32.4999 1 29.0769 1 24.8692C1 20.6615 4.25833 17.2385 8.26368 17.2385C12.2687 17.2385 15.527 20.6615 15.527 24.8692C15.527 29.0769 12.2687 32.4999 8.26368 32.4999ZM8.26368 17.9859C4.65051 17.9859 1.71111 21.0735 1.71111 24.8692C1.71111 28.6649 4.65051 31.7528 8.26368 31.7528C11.8765 31.7528 14.8159 28.6649 14.8159 24.8692C14.8159 21.0735 11.8765 17.9859 8.26368 17.9859Z",
    fill: "#F1935C",
    stroke: "#F1935C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7365 17.5681C25.5399 17.5681 25.3809 17.4011 25.3809 17.1945V13.9647H17.0001C16.8038 13.9647 16.6445 13.7974 16.6445 13.5912V8.8015C16.6445 8.59532 16.8038 8.42798 17.0001 8.42798C17.1964 8.42798 17.3556 8.59532 17.3556 8.8015V13.2177H25.7365C25.9331 13.2177 26.092 13.385 26.092 13.5912V17.1945C26.092 17.4011 25.9331 17.5681 25.7365 17.5681Z",
    fill: "#F1935C",
    stroke: "#F1935C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26376 17.9859C8.06749 17.9859 7.9082 17.8189 7.9082 17.6124V13.5911C7.9082 13.3849 8.06749 13.2175 8.26376 13.2175H17.0002C17.1964 13.2175 17.3557 13.3849 17.3557 13.5911C17.3557 13.7972 17.1964 13.9646 17.0002 13.9646H8.61932V17.6124C8.61932 17.8186 8.46003 17.9859 8.26376 17.9859Z",
    fill: "#F1935C",
    stroke: "#F1935C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankingAnalytics);
export default __webpack_public_path__ + "static/media/bankingAnalytics.f55096ea76d432a2aaf765f8f99d1f14.svg";
export { ForwardRef as ReactComponent };